"use strict";

exports.__esModule = true;
exports.combineMultipleDataIntoCSV = exports.DataItemContextMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _moment = _interopRequireDefault(require("moment"));
var _icons = require("@blueprintjs/icons");
var _core = require("@blueprintjs/core");
var _Utils = require("../../../Utils");
var _Core = require("../../Core");
var _TimeContext = require("../../Time/TimeContext");
var _dec, _class, _DataItemContextMenu;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DataItemContextMenu = exports.DataItemContextMenu = (_dec = _TimeContext.TimeContext.withContext, (0, _Core.withTranslator)(_class = _dec(_class = (_DataItemContextMenu = /*#__PURE__*/function (_Component) {
  function DataItemContextMenu() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleDownload = function () {
      var data = _this.props.data;
      var formattedData = combineMultipleDataIntoCSV(data);
      (0, _Utils.downloadCSVData)(formattedData, "dataitemchart");
    };
    _this.handleContextMenu = function (e) {
      var translator = _this.props.translator;
      e.preventDefault();
      var menu = /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, translator.intl, /*#__PURE__*/_react["default"].createElement(_core.Menu, {
        "data-testid": "ContextMenu"
      }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        icon: _icons.IconNames.DOWNLOAD,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ContextMenu.download",
          defaultMessage: "Download"
        }),
        onClick: _this.handleDownload
      })));
      (0, _core.showContextMenu)({
        content: menu,
        targetOffset: {
          left: e.clientX,
          top: e.clientY
        }
      });
    };
    return _this;
  }
  _inheritsLoose(DataItemContextMenu, _Component);
  var _proto = DataItemContextMenu.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      children = _this$props.children,
      width = _this$props.width,
      height = _this$props.height;
    return /*#__PURE__*/_react["default"].createElement("div", {
      onContextMenu: this.handleContextMenu,
      style: {
        width: width,
        height: height
      }
    }, children);
  };
  return DataItemContextMenu;
}(_react.Component), _DataItemContextMenu.defaultProps = {
  time: undefined,
  translator: undefined,
  data: []
}, _DataItemContextMenu)) || _class) || _class);
var combineMultipleDataIntoCSV = exports.combineMultipleDataIntoCSV = function combineMultipleDataIntoCSV(data) {
  return data.reduce(function (acc, dataItemProps) {
    var dataItemFormattedData = (0, _Utils.exportDataToCSVFormat)(dataItemProps.data, {
      columns: {
        timestamp: "Timestamp",
        type: "Data Item Type",
        name: "Data Item Name",
        value: "Value"
      },
      formatter: {
        timestamp: function timestamp(item) {
          return _moment["default"].utc(item.key).toISOString().replace("T", " ").replace("Z", "");
        },
        name: function name() {
          return dataItemProps.name;
        },
        type: function type() {
          return dataItemProps.type;
        }
      }
    });
    return {
      headers: dataItemFormattedData.headers,
      rows: [].concat(acc.rows, dataItemFormattedData.rows)
    };
  }, {
    headers: [],
    rows: []
  });
};